.atm_2d_1j28jx2.atm_2d_1j28jx2{background-color:transparent;}
.atm_3f_okh77k{border:1px solid transparent;}
.atm_5j_1y44olf{border-radius:4px;}
.atm_9s_1txwivl{display:flex;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_fc_1h6ojuz.atm_fc_1h6ojuz{justify-content:center;}
.atm_uc_lmavda{transition:background-color 250ms ease-in-out;}
.atm_l8_ftgil2{padding:8px;}
.atm_cx_ftgil2{gap:8px;}
.atm_mk_h2mmj6{position:relative;}
.atm_17yrrpa_glywfm:focus-visible{outline:none;}
.atm_1yl5u20_1rsymlf:focus-visible{box-shadow:0 0 0 2px white,0 0 0 4px #146EF5;}
.atm_uxdxss_kb7nvz:focus:not(:active)::before,.atm_uxdxss_kb7nvz:focus-within:not(:active)::before{opacity:1;}
.atm_75y05d_118lp2q:hover:not([aria-disabled='true']),.atm_75y05d_118lp2q:focus{background:#F4F5F7;}
.atm_1eekado_15clnoc:hover:not([aria-disabled='true']),.atm_1eekado_15clnoc:focus{transition:fill 250ms ease-in-out;}
.atm_1rxcd5n_73adwj[aria-disabled='true']{cursor:default;}
.atm_1rm36dh_j1e0tf[aria-disabled='true']{color:#CED3DA;}
.atm_aizt47_j1e0tf[aria-disabled='true'] svg{fill:#CED3DA;}
.atm_jb_1ylpe5n{min-width:40px;}
.atm_e2_1ylpe5n{height:40px;}
.atm_c8_1j6vyhq.atm_c8_1j6vyhq{font-size:1rem;}
.atm_vy_1ylpe5n{width:40px;}
.atm_jb_1vi7ecw{min-width:32px;}
.atm_e2_1vi7ecw{height:32px;}
.atm_c8_1x7uoys.atm_c8_1x7uoys{font-size:0.875rem;}
.atm_vy_1vi7ecw{width:32px;}
.atm_jb_1tcgj5g{min-width:24px;}
.atm_e2_1tcgj5g{height:24px;}
.atm_vy_1tcgj5g{width:24px;}
.atm_jb_exct8b{min-width:16px;}
.atm_e2_exct8b{height:16px;}
.atm_vy_exct8b{width:16px;}
.atm_ar_vrvcex.atm_ar_vrvcex{flex-direction:row;}
.atm_ar_1sbvcyy.atm_ar_1sbvcyy{flex-direction:row-reverse;}
.atm_7l_9ztun4{color:#DD3131;}
.atm_leio7s_9ztun4 svg{fill:#DD3131;}
.atm_7l_pr0y3d{color:#32373E;}
.atm_18uqgji_pr0y3d:hover{color:#32373E;}
.atm_symwhj_pr0y3d:hover:not([aria-disabled='true']) svg,.atm_symwhj_pr0y3d:focus svg{fill:#32373E;}
.atm_vy_1wugsn5{width:auto;}
.atm_jxpu17_1y44olf::before{border-radius:4px;}
.atm_akuhtt_54a6mi:hover:not([aria-disabled='true']) svg:focus::before,.atm_akuhtt_54a6mi:focus svg:focus::before{width:calc(100% + 8px);}
.atm_1blml9j_54a6mi:hover:not([aria-disabled='true']) svg:focus::before,.atm_1blml9j_54a6mi:focus svg:focus::before{height:calc(100% + 8px);}
